<template>
  <div>
    <div
      v-if="
        !isEmpty(groupProgress) &&
        groupProgress.progressPercentage > 0 &&
        group.memberRole == 'M'
      "
    >
      <div
        class="box is-boxed-2"
        style="margin-bottom: 20px; padding: 20px 0 20px 25px"
        v-if="groupProgress.progressPercentage >= 100"
      >
        <div class="columns is-vcentered">
          <div class="column">
            <p class="title has-text-darkblue font-24 font-w-600">
              Selamat Kamu Lulus
            </p>
            <p class="subtitle font-16" style="color: #394693">
              Kamu berhasil lulus dari kelas ini dan layak memperoleh
              sertifikat. Selamat ya!
            </p>

            <a
              class="has-text-primary font-16 font-w-600"
              href=""
              @click.prevent="viewCertificate"
              >Lihat E-Sertifikat</a
            >
          </div>

          <div class="column is-narrow">
            <img
              src="/assets/img/class-passed.svg"
              style="width: 164px"
              alt=""
            />
          </div>
        </div>

        <b-modal v-if="generate_certificate" :active.sync="generate_certificate" :width="600" scroll="keep">
          <div class="card is-boxed-3 is-paddingless">
            <div class="card-header">
              <p class="card-header-title">Dapatkan E-Sertifikat</p>
              <a class="card-header-icon" aria-label="more options" @click.prevent="generate_certificate = false">
                <span class="icon">
                  <i class="fas fa-times" aria-hidden="true"></i>
                </span>
              </a>
            </div>
            <div class="card-content" style="padding: 15px 15px 25px; overflow: auto;">
              <preview-certificate-aws :certificate="certificate" v-if="group.certificateType == 'AWS'"></preview-certificate-aws>
              <preview-certificate :certificate="certificate" v-else></preview-certificate>

              <div class="notification is-primary4 font-14" style="padding: 7px 15px;">
                Untuk mendapatkan <strong>E-Sertifikat</strong>, silakan lengkapi data diri Anda dan pastikan data yang Anda masukkan telah sesuai. Karena setelah E-Sertifikat telah diberikan <strong>data tidak bisa diubah</strong>.
              </div>

              <b-field label="Nama Lengkap" message="Nama Lengkap maksimal 50 karakter" aria-required="true">
                <b-input placeholder="Nama Lengkap" maxlength="50" v-model="certificate.user_name"></b-input>
              </b-field>
              
              <b-field label="Alamat" message="Alamat pengiriman merchandise [Jika beruntung]">
                <b-input placeholder="Alamat lengkap" maxlength="200"  v-model="certificate.address" type="textarea"></b-input>
              </b-field>

              <b-field label="No. Telp">
                <b-input placeholder="No. Telp" maxlength="15" v-model="certificate.phone_number"></b-input>
              </b-field>
            </div>
            <div class="card-footer">
              <a class="card-footer-item" @click.prevent="validateGenerateNewCertificate" :disabled="loading_generate_certificate" :class="{'is-loading': loading_generate_certificate}">Dapatkan E-Sertifikat</a>
            </div>
          </div>
        </b-modal>
      </div>

      <div
        class="box is-boxed-2"
        style="margin-bottom: 20px; padding: 0"
        v-else-if="
          !isEmpty(groupProgress) &&
          groupProgress.viewAllMaterials &&
          groupProgress.finishedAllQuizesAndAssignments &&
          !groupProgress.finalTestPassed &&
          group.memberRole == 'M' &&
          !isEmpty(groupProgress.finalTest) &&
          groupProgress.finalTest.quiz.isRetakeable
        "
      >
        <div style="padding: 20px">
          <p class="title has-text-darkblue font-18 font-w-600">
            Belum Berhasil Lulus Kelas
          </p>
          <p class="subtitle font-14" style="color: #394693">
            Sayang sekali, kamu belum berhasil lulus di kelas ini. Kamu bisa
            mencoba lagi untuk mengerjakan Kuis Akhir nantinya.
          </p>

          <div class="is-relative">
            <div
              class="overlay"
              style="
                backdrop-filter: blur(6px);
                background-color: rgba(0, 0, 0, 0.8);
                border-radius: 8px;
              "
              v-if="!is_final_test_available"
            >
              <div
                class="columns is-vcentered has-text-centered"
                style="margin: 0; height: 100%"
              >
                <div class="column">
                  <p class="subtitle font-w-500 font-14 has-text-white">
                    Waktu menuju pengerjaan kembali :
                  </p>
                  <p class="title font-w-600 font-20 has-text-white">
                    <countdown
                      :finished="next_final_test_available"
                      :onExpired="onQuizAvailable"
                    ></countdown>
                  </p>
                </div>
              </div>
            </div>
            <div class="middle-content">
              <div class="tugas__content-timeline">
                <div class="content" style="margin-bottom: 0">
                  <img
                    src="/assets/img/v1/icon/icon_ tugas.svg"
                    class="icon-content"
                    alt=""
                  />
                  <div class="keterangan" style="width: 100%">
                    <div class="header-content">
                      <div class="title-content">
                        <b-tooltip
                          :label="groupProgress.finalTest.title"
                          type="is-dark"
                        >
                          <h6>
                            <a
                              class="has-tex-darkblue"
                              @click.prevent="
                                group.type == 'A'
                                  ? toDetailPost(groupProgress.finalTest, 'classes')
                                  : toDetailPost(groupProgress.finalTest, 'groups')
                              "
                              >{{ groupProgress.finalTest.title }}</a
                            >
                          </h6>
                        </b-tooltip>

                        <div class="columns">
                          <div class="column">
                            <p class="text-secondary">
                              Batas waktu pengerjaan:
                              <span
                                v-if="
                                  groupProgress.finalTest.quiz.finishedAt > 0
                                "
                                >{{
                                  dateFormat(
                                    groupProgress.finalTest.quiz.finishedAt,
                                    "DD MMM YYYY . HH:mm"
                                  )
                                }}</span
                              ><span v-else>Tidak ada</span>
                            </p>
                          </div>
                        </div>
                      </div>

                      <div class="btn-upload">
                        <button
                          class="button is-tugas"
                          @click.prevent="
                            group.type == 'A'
                              ? toDetailPost(groupProgress.finalTest, 'classes')
                              : toDetailPost(groupProgress.finalTest, 'groups')
                          "
                        >
                          <span>Kerjakan Quiz</span>
                        </button>
                      </div>
                    </div>

                    <div class="desc">
                      <span class="desc-title"
                        >{{
                          groupProgress.finalTest.quiz.questionsCount
                        }}
                        Pertanyaan</span
                      >
                      <pre
                        class="font-secondary font-12"
                        style="
                          background: transparent;
                          padding: 0;
                          white-space: pre-line;
                          margin-bottom: 0;
                        "
                        v-html="groupProgress.finalTest.excerpt"
                      ></pre>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        class="box is-boxed-2"
        style="margin-bottom: 20px; padding: 0"
        v-else-if="
          (isEmpty(groupProgress) || groupProgress.progressPercentage < 100) &&
          group.memberRole == 'M'
        "
      >
        <div style="padding: 20px">
          <p class="title has-text-darkblue font-18 font-w-600">
            Sedikit lagi kamu lulus
          </p>
          <p class="subtitle font-14" style="color: #394693">
            Selesaikan poin - poin yang belum selesai dibawah ini dan dapatkan
            E-Sertifikat barumu.
          </p>
        </div>

        <ul>
          <li
            style="
              border-top: 1px solid #e2e7ff;
              border-bottom: 1px solid #e2e7ff;
              padding: 16px 20px;
            "
          >
            <div class="columns is-vcentered">
              <div class="column is-narrow">
                <svg
                  v-if="isEmpty(groupProgress) || !groupProgress.viewAllMaterials"
                  style="margin-bottom: -4px"
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M10 0C4.48625 0 0 4.48625 0 10C0 15.5138 4.48625 20 10 20C15.5138 20 20 15.5138 20 10C20 4.48625 15.5138 0 10 0ZM10 15.8337C9.54 15.8337 9.16625 15.4613 9.16625 15C9.16625 14.54 9.53875 14.1663 10 14.1663C10.46 14.1663 10.8337 14.5387 10.8337 15C10.8337 15.46 10.46 15.8337 10 15.8337ZM11.3188 10.535C11.0238 10.6712 10.8325 10.9688 10.8325 11.2925V11.6663C10.8338 12.1275 10.46 12.5 10 12.5C9.54 12.5 9.16625 12.1263 9.16625 11.6663V11.2925C9.16625 10.32 9.7375 9.42875 10.62 9.02125C11.4688 8.63 12.0825 7.5925 12.0825 7.08375C12.0838 5.935 11.1488 5 10 5C8.85125 5 7.91625 5.935 7.91625 7.08375C7.91625 7.54375 7.54375 7.9175 7.0825 7.9175C6.6225 7.9175 6.24875 7.54375 6.24875 7.08375C6.24875 5.01625 7.93125 3.33375 9.99875 3.33375C12.0662 3.33375 13.7488 5.01625 13.7488 7.08375C13.75 8.20875 12.7738 9.865 11.3188 10.535Z"
                    fill="#394693"
                  />
                </svg>
                <svg
                  v-else-if="!isEmpty(groupProgress) && groupProgress.viewAllMaterials"
                  style="margin-bottom: -4px"
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M10 0C4.48639 0 0 4.48639 0 10C0 15.5136 4.48639 20 10 20C15.5136 20 20 15.5136 20 10C20 4.48639 15.5136 0 10 0ZM15.0687 7.88116L9.6524 13.2974C9.49005 13.4601 9.27612 13.5413 9.06372 13.5413C8.8501 13.5413 8.63739 13.4601 8.47504 13.2974L5.7663 10.5887C5.44128 10.2637 5.44128 9.73633 5.7663 9.4101C6.09131 9.08386 6.61865 9.08508 6.94489 9.4101L9.06372 11.5286L13.8913 6.70135C14.2163 6.37634 14.7437 6.37634 15.0699 6.70135C15.3961 7.02637 15.3937 7.55493 15.0687 7.88116Z"
                    fill="#279B24"
                  />
                </svg>
              </div>
              <div class="column">
                <span
                  class="font-14"
                  :class="{
                    'has-text-darkblue':
                      isEmpty(groupProgress) || !groupProgress.viewAllMaterials,
                    'has-text-primary':
                      !isEmpty(groupProgress) && groupProgress.viewAllMaterials,
                  }"
                  >Melihat semua materi dalam setiap sesi</span
                >
              </div>

              <!-- <div class="column is-narrow">
                <a href=""><i class="fas fa-chevron-right has-text-grey"></i></a>
              </div> -->
            </div>
          </li>
          <li style="padding: 16px 20px; border-bottom: 1px solid #e2e7ff">
            <div class="columns is-vcentered">
              <div class="column is-narrow">
                <svg
                  v-if="
                    isEmpty(groupProgress) ||
                    !groupProgress.finishedAllQuizesAndAssignments
                  "
                  style="margin-bottom: -4px"
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M10 0C4.48625 0 0 4.48625 0 10C0 15.5138 4.48625 20 10 20C15.5138 20 20 15.5138 20 10C20 4.48625 15.5138 0 10 0ZM10 15.8337C9.54 15.8337 9.16625 15.4613 9.16625 15C9.16625 14.54 9.53875 14.1663 10 14.1663C10.46 14.1663 10.8337 14.5387 10.8337 15C10.8337 15.46 10.46 15.8337 10 15.8337ZM11.3188 10.535C11.0238 10.6712 10.8325 10.9688 10.8325 11.2925V11.6663C10.8338 12.1275 10.46 12.5 10 12.5C9.54 12.5 9.16625 12.1263 9.16625 11.6663V11.2925C9.16625 10.32 9.7375 9.42875 10.62 9.02125C11.4688 8.63 12.0825 7.5925 12.0825 7.08375C12.0838 5.935 11.1488 5 10 5C8.85125 5 7.91625 5.935 7.91625 7.08375C7.91625 7.54375 7.54375 7.9175 7.0825 7.9175C6.6225 7.9175 6.24875 7.54375 6.24875 7.08375C6.24875 5.01625 7.93125 3.33375 9.99875 3.33375C12.0662 3.33375 13.7488 5.01625 13.7488 7.08375C13.75 8.20875 12.7738 9.865 11.3188 10.535Z"
                    fill="#394693"
                  />
                </svg>
                <svg
                  v-else-if="
                    !isEmpty(groupProgress) &&
                    groupProgress.finishedAllQuizesAndAssignments
                  "
                  style="margin-bottom: -4px"
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M10 0C4.48639 0 0 4.48639 0 10C0 15.5136 4.48639 20 10 20C15.5136 20 20 15.5136 20 10C20 4.48639 15.5136 0 10 0ZM15.0687 7.88116L9.6524 13.2974C9.49005 13.4601 9.27612 13.5413 9.06372 13.5413C8.8501 13.5413 8.63739 13.4601 8.47504 13.2974L5.7663 10.5887C5.44128 10.2637 5.44128 9.73633 5.7663 9.4101C6.09131 9.08386 6.61865 9.08508 6.94489 9.4101L9.06372 11.5286L13.8913 6.70135C14.2163 6.37634 14.7437 6.37634 15.0699 6.70135C15.3961 7.02637 15.3937 7.55493 15.0687 7.88116Z"
                    fill="#279B24"
                  />
                </svg>
              </div>
              <div class="column">
                <span
                  class="font-14"
                  :class="{
                    'has-text-darkblue':
                      isEmpty(groupProgress) ||
                      !groupProgress.finishedAllQuizesAndAssignments,
                    'has-text-primary':
                      !isEmpty(groupProgress) &&
                      groupProgress.finishedAllQuizesAndAssignments,
                  }"
                  >Mengerjakan semua quiz & tugas yang ada</span
                >
              </div>

              <!-- <div class="column is-narrow">
                <a href=""><i class="fas fa-chevron-right has-text-grey"></i></a>
              </div> -->
            </div>
          </li>
          <li
            style="padding: 16px 20px"
            v-if="!isEmpty(groupProgress) && !isEmpty(groupProgress.finalTest)"
          >
            <div class="columns is-vcentered">
              <div class="column is-narrow">
                <svg
                  v-if="!groupProgress.finalTestPassed"
                  style="margin-bottom: -4px"
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M10 0C4.48625 0 0 4.48625 0 10C0 15.5138 4.48625 20 10 20C15.5138 20 20 15.5138 20 10C20 4.48625 15.5138 0 10 0ZM10 15.8337C9.54 15.8337 9.16625 15.4613 9.16625 15C9.16625 14.54 9.53875 14.1663 10 14.1663C10.46 14.1663 10.8337 14.5387 10.8337 15C10.8337 15.46 10.46 15.8337 10 15.8337ZM11.3188 10.535C11.0238 10.6712 10.8325 10.9688 10.8325 11.2925V11.6663C10.8338 12.1275 10.46 12.5 10 12.5C9.54 12.5 9.16625 12.1263 9.16625 11.6663V11.2925C9.16625 10.32 9.7375 9.42875 10.62 9.02125C11.4688 8.63 12.0825 7.5925 12.0825 7.08375C12.0838 5.935 11.1488 5 10 5C8.85125 5 7.91625 5.935 7.91625 7.08375C7.91625 7.54375 7.54375 7.9175 7.0825 7.9175C6.6225 7.9175 6.24875 7.54375 6.24875 7.08375C6.24875 5.01625 7.93125 3.33375 9.99875 3.33375C12.0662 3.33375 13.7488 5.01625 13.7488 7.08375C13.75 8.20875 12.7738 9.865 11.3188 10.535Z"
                    fill="#394693"
                  />
                </svg>
                <svg
                  v-else-if="!isEmpty(groupProgress) && groupProgress.finalTestPassed"
                  style="margin-bottom: -4px"
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M10 0C4.48639 0 0 4.48639 0 10C0 15.5136 4.48639 20 10 20C15.5136 20 20 15.5136 20 10C20 4.48639 15.5136 0 10 0ZM15.0687 7.88116L9.6524 13.2974C9.49005 13.4601 9.27612 13.5413 9.06372 13.5413C8.8501 13.5413 8.63739 13.4601 8.47504 13.2974L5.7663 10.5887C5.44128 10.2637 5.44128 9.73633 5.7663 9.4101C6.09131 9.08386 6.61865 9.08508 6.94489 9.4101L9.06372 11.5286L13.8913 6.70135C14.2163 6.37634 14.7437 6.37634 15.0699 6.70135C15.3961 7.02637 15.3937 7.55493 15.0687 7.88116Z"
                    fill="#279B24"
                  />
                </svg>
              </div>
              <div class="column">
                <span
                  class="font-14"
                  :class="{
                    'has-text-darkblue': !groupProgress.finalTestPassed,
                    'has-text-primary':
                      !isEmpty(groupProgress) && groupProgress.finalTestPassed,
                  }"
                >
                  Memperoleh nilai kuis akhir
                  <span
                    v-if="
                      !isEmpty(groupProgress) && groupProgress.finalTestGradeLimit == 100
                    "
                    >sama dengan </span
                  ><span v-else>lebih dari</span>
                  {{ !isEmpty(groupProgress) ? groupProgress.finalTestGradeLimit : 60 }}
                </span>
              </div>

              <!-- <div class="column is-narrow">
                <a href=""><i class="fas fa-chevron-right has-text-grey"></i></a>
              </div> -->
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import Countdown from "~/components/Countdown";
import CLASSES_MIXIN from "~/mixins/classes";
import PreviewCertificate from "./PreviewCertificate";
import PreviewCertificateAws from "./PreviewCertificateAws";

export default {
  mixins: [CLASSES_MIXIN],

  components: {
    Countdown,
    PreviewCertificate,
    PreviewCertificateAws
  },

  props: {
    groupProgress: {
      type: Object,
      default: null,
    },
    group: {
      type: Object,
      required: true,
    },
  },

  computed: {
    is_final_test_available: {
      get() {
        let is_final_test_available = this.isFinalTestAvailable;

        if (
          !this.isEmpty(this.groupProgress) &&
          this.groupProgress.lastFinishedFinalTest > 0 &&
          is_final_test_available === false
        ) {
          if (
            !this.groupProgress.finalTestPassed &&
            !this.isDateBetween(
              this.groupProgress.lastFinishedFinalTest,
              this.next_final_test_available
            ) &&
            !this.isEmpty(this.groupProgress.finalTest) &&
            this.groupProgress.finalTest.quiz.totalRetake < this.groupProgress.finalTest.quiz.maxRetake
          ) {
            is_final_test_available = true;
          }
        }

        return is_final_test_available;
      },
      set(val) {
        this.isFinalTestAvailable = val;
      }
    },
    next_final_test_available() {
      let next_final_test_available = null;

      if (
        !this.isEmpty(this.groupProgress) &&
        this.groupProgress.lastFinishedFinalTest > 0 &&
        !this.isEmpty(this.groupProgress.finalTest) &&
        !this.isEmpty(this.groupProgress.finalTest.quiz) &&
        this.groupProgress.finalTest.quiz.isRetakeable &&
        !this.isEmpty(this.groupProgress.finalTest.quiz.pauseRetake)
      ) {
        next_final_test_available = this._moment(
          this.groupProgress.lastFinishedFinalTest
        )
          .add(this.groupProgress.finalTest.quiz.pauseRetake, "seconds")
          .format("YYYY-MM-DD HH:mm:ss");
      }

      return next_final_test_available;
    },
  },

  data() {
    return {
      generate_certificate: false,
      loading_generate_certificate: false,
      certificate: {
        user_name: _.clone(this.$store.state.auth.name),
        class_name: this.group.name,
        certificate_id: "XXXXXXXXXXXXXXXX",
        address: '',
        phone_number: ''
      },
      isFinalTestAvailable: false
    };
  },

  methods: {
    toDetailPost(post, group_type) {
      const vm = this;

      if (["G", "P", "0", "D"].indexOf(this.group.type) > -1) {
        window.open(post.extUrl, "_blank");
      } else if (this.group.type == "U") {
        vm.$router.push({ path: `/panel/university/news/${post.id}` });
      } else if (
        !vm.isEmpty(post.classScheduleId) &&
        ["M", "Z", "Q", "V"].indexOf(post.type) > -1
      ) {
        vm.$router.push({
          path: `/panel/${group_type}/${vm.group.id}/sections/${post.classScheduleId}/${post.id}`,
        });
      } else {
        vm.$router.push({
          path: `/panel/${group_type}/${vm.group.id}/${post.id}`,
        });
      }
    },
    async viewCertificate() {
      let data = await this.getCertificate(this.group.memberId);
      if (this.isEmpty(data)) {
        this.generate_certificate = true;
      }
    },
    validateGenerateNewCertificate() {
      const vm = this;

      if (vm.group.certificateType == 'AWS') {
        if (vm.certificate.user_name.length == 0) {
          toast.danger('Nama lengkap harus diisi');
          return;
        }
        if (vm.certificate.address.length == 0) {
          toast.danger('Alamat harus diisi');
          return;
        }
        if (vm.certificate.phone_number.length == 0) {
          toast.danger('Nomor telepon harus diisi');
          return;
        }
        if (!(/^\d+$/.test(vm.certificate.phone_number))) {
          toast.danger('Nomor telepon hanya boleh angka');
          return;
        }
        
        this.generateNewCertificate();
      } else {
        this.generateNewCertificate();
      }
    },
    async generateNewCertificate() {
      if (this.loading_generate_certificate) {
        return;
      }

      this.loading_generate_certificate = true
      await this.generateCertificate({ user_name: this.certificate.user_name, gmid: this.group.memberId, address: this.certificate.address, phone_number: this.certificate.phone_number });
      this.generate_certificate = false
      this.loading_generate_certificate = false
    },
    onQuizAvailable() {
      this.is_final_test_available = true;
    }
  },
};
</script>

<style>
</style>
